/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import { preconfigureLayoutLinkClick } from '../../../analytics';

export default (set, get, templateName) => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = { event: [] };
  }

  const preconfiguredLinkTemplate = { templateName };

  draft.digitalData.preconfiguredLinkTemplate = preconfiguredLinkTemplate;

  preconfigureLayoutLinkClick(preconfiguredLinkTemplate);
}), false, { type: 'TRACK_PRECONFIGURED_LAYOUT_LINK_CLICK' });
